import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Copy, Check, Share2 } from 'lucide-react';

/**
 * PdfShareCard — Admin-Tool: zeigt den öffentlichen PDF-Link
 * (`{origin}/pdf`) mit Copy-Button und QR-Code für WhatsApp/Handy.
 * Der Link ist ohne Login zugänglich und bietet nur die PDF-Downloads.
 */
export default function PdfShareCard() {
  const [copied, setCopied] = useState(false);

  // Baue die public URL aus dem aktuellen origin — funktioniert in Preview,
  // Production und lokal.
  const pdfUrl = typeof window !== 'undefined' ? `${window.location.origin}/pdf` : '/pdf';

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(pdfUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (_) {
      // Fallback für ältere Browser
      const el = document.createElement('input');
      el.value = pdfUrl;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    }
  };

  return (
    <div className="mt-4 p-3 rounded border border-white/10 bg-white/[0.03]" data-testid="pdf-share-card">
      <div className="text-[10px] uppercase tracking-[0.2em] text-white/40 mb-2 flex items-center gap-1.5">
        <Share2 size={12} /> PDF-Link teilen
      </div>

      <p className="text-[11px] text-white/50 mb-3 leading-relaxed">
        Öffentlicher Link (kein Login nötig) — leitet direkt auf die PDF-Downloads.
      </p>

      <div className="flex gap-2 mb-3">
        <input
          type="text"
          readOnly
          value={pdfUrl}
          data-testid="pdf-share-url"
          className="flex-1 bg-black/40 border border-white/10 rounded px-2 py-1.5 text-[11px] text-white/85 font-mono select-all"
          onClick={(e) => e.target.select()}
        />
        <button
          type="button"
          onClick={copy}
          data-testid="pdf-share-copy"
          className={`text-[10px] uppercase tracking-[0.12em] px-3 rounded border transition-colors inline-flex items-center gap-1.5 ${
            copied
              ? 'border-emerald-400/40 text-emerald-300'
              : 'border-white/25 text-white/85 hover:border-white/60'
          }`}
        >
          {copied ? <><Check size={12} /> Kopiert</> : <><Copy size={12} /> Kopieren</>}
        </button>
      </div>

      <div className="flex justify-center p-3 rounded bg-white">
        <QRCodeSVG
          value={pdfUrl}
          size={160}
          level="M"
          data-testid="pdf-share-qr"
          bgColor="#ffffff"
          fgColor="#000000"
        />
      </div>
      <p className="text-[10px] text-white/40 text-center mt-2">
        QR-Code scannen für Handy-Download
      </p>
    </div>
  );
}
